<div class="flex-col" style="width: 100%;">
  <!-- mobile header -->
  @if (record) {
    <div #mobileHeader [ngClass]='statusClass' class="trip-booking-mobile-header fx-row fx-justify-center fx-items-center" style="gap: 12px">
      <span class="material-icons-outlined">confirmation_number</span>
      <span class="booking-code">{{'Prenotazione' | translate}} {{record.booking_code}}</span>
      @if (record) {
        @switch (record.status) {
          @case ("confirmed") {
            <span class='h4 secondary-text'>{{'Confermata' | translate}}</span>
          }
          @case ("mix") {
            <span class='h4 secondary-text'>{{'Mista' | translate}}</span>
          }
          @case ("canceled") {
            <span class='h4 secondary-text'>{{'Cancellata' | translate}}</span>
          }
          @case ("optional") {
            <span
            class='h4 secondary-text '>{{'Opzionale (in scadenza)' | translate}}</span>
          }
          @case ("expired") {
            <span class='h4 secondary-text'>{{'Scaduta' | translate}}</span>
          }
          @case ("unconfirmed") {
            <span
            class='h4 secondary-text'>{{'Non Confermata' | translate}}</span>
          }
          @case ("draft") {
            <span class='h4 secondary-text'>{{'Preventivo' | translate}}</span>
          }
        }
      }
    </div>
  }

  <!-- mobile horizontal stepper -->
  <trip-booking-stepper #bookingStepperComponent layout="horizontal" [record]="record" (stepChange)="stepChange($event)" class="fx-hide-gt-md"></trip-booking-stepper>

  <div class="page-layout p-16 blank simple left-sidebar booking-page">
    <div class="top-bg accent"></div>
    @if (!record) {
      <div class="progressbar fx-row" style="width: 100%">
        <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
      </div>
    }
    @if (record) {
      <!-- fuse sidebar vertical stepper -->
      <trip-booking-stepper #bookingStepperComponent layout="vertical" [record]="record" (stepChange)="stepChange($event)" class="fx-hide-lt-md"></trip-booking-stepper>
      <div class="center">
        <div class="content booking-page-content p-16">
          @if (bookingService.useLastDraft && record && isDraft) {
            <mat-card class='m-12 p-4' class='primary pending-booking-msg'>
              <mat-card-content>
                <p>{{'Stai modificando una prenotazione non terminata' | translate}}.</p>
              </mat-card-content>
              <mat-action-list>
                <button mat-flat-button (click)='bookingService.useLastDraft = false'>{{'Chiudi messaggio' | translate}}</button>
                <button mat-flat-button color='warn' (click)='cancelPermanentBooking()'>{{'Cancella Permanentemente' | translate}}</button>
              </mat-action-list>
            </mat-card>
          }
          @if (record.status === "optional" && deadlineDate) {
            <mat-card class='m-12 p-4' style='max-width:500px' class='orange'>
              <mat-card-content>
                @if (deadlineDate > now) {
                  <p class='orange-50-fg'>{{'Questa prenotazione se non confermata scadrà il' | translate}} {{deadlineDate.format('DD/MM/YYYY HH:mm')}}</p>
                }
                @if (deadlineDate <= now) {
                  <p class='orange-50-fg'>{{'Questa prenotazione è scaduta il' | translate}} {{deadlineDate.format('DD/MM/YYYY HH:mm')}}</p>
                }
              </mat-card-content>
            </mat-card>
          }
          <!-- payment -->
          @if (record.method_payment && record.method_payment_status != "refunded") {
            <mat-card class='m-12 p-4' class='primary'>
              <mat-card-content>
                <p>{{'La prenotazione è stata saldata tramite il seguente metodo di pagamento' | translate}}: <b>{{record.method_payment}}</b></p>
              </mat-card-content>
            </mat-card>
          }
          @if (record.method_payment && record.method_payment_status == "refunded") {
            <mat-card class='m-12 p-4' class='red'>
              <mat-card-content>
                <p>{{'La prenotazione è stata rimborsata tramite il seguente metodo di pagamento' | translate}}: <b>{{record.method_payment}}</b></p>
              </mat-card-content>
            </mat-card>
          }
          <!--
          Metodo di incasso per il documento fiscale: stesso banner del metodo di
          pagamento, mostrato solo dove la prenotazione genera un documento RT (il
          backend lo segnala in backoffice_required_fields) o dove un metodo è già
          stato dichiarato, così resta correggibile anche a posteriori.
          -->
          @if (rtPaymentMethodRequired || record.rt_payment_method_code) {
            <mat-card
              [ngClass]='rtPaymentStatusClass' style="margin-top: 12px;">
              <mat-card-content class='fx-row fx-justify-space-between fx-items-center' style='gap: 8px'>
                @if (record.rt_payment_method_code) {
                  <p class='m-0'>
                    {{'La prenotazione è stata incassata con il seguente metodo di incasso' | translate}}:
                    <b>{{record.rt_payment_method_description || record.rt_payment_method_code}}</b>
                  </p>
                }
                @if (!record.rt_payment_method_code) {
                  <p class='m-0'>
                    {{'Metodo di incasso non impostato' | translate}}@if (rtPaymentMethodRequired) {
                    :
                    {{'la conferma resta bloccata finché non lo imposti' | translate}}
                  }
                </p>
              }
              <!-- pagamento elettronico tracciato dopo la conferma: dato non modificabile -->
              @if (record.can_edit_rt_payment_method) {
                <button mat-flat-button (click)='setRtPaymentMethod()'>
                  @if (record.rt_payment_method_code) {
                    <span>{{'Modifica' | translate}}</span>
                  }
                  @if (!record.rt_payment_method_code) {
                    <span>{{'Imposta' | translate}}</span>
                  }
                </button>
              }
            </mat-card-content>
          </mat-card>
        }
        <!-- document rt -->
        @if (record.document_rt) {
          <mat-card [ngClass]='record.status == "canceled" ? "warn" : "success"' style="margin-top: 12px;">
            <mat-card-content>
              <span><b>{{'Data e Ora documento' | translate}}</b>: {{ record.document_rt.data_scontrino }}</span> |
              <span><b>{{'Numero Documento' | translate}}</b>: {{ record.document_rt.ClosureNumber }} / {{ record.document_rt.DocumentNumber }}</span> |
              <span><b>{{'Matricola Cassa' | translate}}</b>: {{ record.document_rt.ServerRtSerialNumber }}</span> |
              <span><b>{{'Matricola Server' | translate}}</b>: {{ record.document_rt.Till_ID }}</span>
            </mat-card-content>
          </mat-card>
        }
        <mat-tab-group class='tab-hidden-header' [selectedIndex]='stepIndex'>
          <mat-tab>
            <ng-template matTabContent>
              <trip-booking-packages-step></trip-booking-packages-step>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template matTabContent>
              <edit-booking-step-0></edit-booking-step-0>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template matTabContent>
              <edit-booking-step-1></edit-booking-step-1>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template matTabContent>
              <edit-booking-step-3></edit-booking-step-3>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
      <!-- navigation on desktop -->
      @if (!datasetACS.loading.value) {
        <hr class="divider desktop">
        <div class="navigation desktop">
          @if (stepIndex > 0) {
            @if (bookingService.canEdit) {
              <div class='mt-24 mb-24 navigate_prev'>
                <div style="display: flex; align-items: center;" (click)="bookingStepperComponent.previous()">
                  <span class="material-icons-outlined round_next">arrow_back_ios_new</span>
                  <a mat-flat-button disableRipple>{{'Indietro' | translate}}</a>
                </div>
              </div>
            }
          }
          @if (stepIndex < 3) {
            @if (bookingService.canEdit) {
              <div class='mt-24 mb-24 navigate_next'>
								<div	style="display: flex; 
											align-items: center;" 
                  [ngClass]="{'disabled_next_booking_step': !enabledNextBookingStep}"
                  (click)="bookingStepperComponent.next()">
                  <a mat-flat-button disableRipple>{{ (stepIndex == 0 ? 'Vai avanti' : 'Salva e vai avanti') | translate}}</a>
                  <span class="material-icons-outlined round_next">arrow_forward_ios</span>
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
    <!-- right sidebar -->
    <fuse-sidebar class="right" name="page-right-sidebar" position="right" lockedOpen="gt-sm">
      @if (datasetRS.loading.value) {
        <div class="overlay"></div>
      }
      <div class="fx-column fx-flex-1-1-0" style="gap: 24px">
        <div [ngClass]='statusClass' class="header p-16 accent">
          <!-- booking code -->
          <h2 class="m-0 booking_title">
            <span class="material-icons-outlined icon">confirmation_number</span> {{'Prenotazione' | translate}}
            @if (record.booking_code) {
              <span (click)="onViewLogs()" class="booking_code">{{record.booking_code}}</span>
            }
          </h2>
          <!-- status -->
          @if (record) {
            @switch (record.status) {
              @case ("mix") {
                <span class='h4 secondary-text'>{{'Mista' | translate}}</span>
              }
              @case ("confirmed") {
                <span class='h4 secondary-text'>{{'Confermata' | translate}}</span>
              }
              @case ("canceled") {
                <span class='h4 secondary-text'>{{'Cancellata' | translate}}</span>
              }
              @case ("optional") {
                <span class='h4 secondary-text '>{{'Opzionale (in scadenza)' | translate}}</span>
              }
              @case ("expired") {
                <span class='h4 secondary-text'>{{'Scaduta' | translate}}</span>
              }
              @case ("unconfirmed") {
                <span class='h4 secondary-text'>{{'Non Confermata' | translate}}</span>
              }
              @case ("draft") {
                <span class='h4 secondary-text'>{{'Preventivo' | translate}}</span>
              }
            }
          }
        </div>
        <div class="actions">
          @if (["confirmed", "mix"].includes(record.status) && hasPackages) {
            <div class="voucher-actions fx-column fx-justify-start fx-items-start" style="gap: 10px">
              <h4 style="margin-top: 0;">{{'Voucher prenotazione' | translate}}</h4>
              <span class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
                <i class="material-icons-outlined">print</i>
                <a class="print-voucher"
                  [href]='appService.getBaseServerAddressRoot() + "/voucher/download/by/id/" + datasetRS.recordId'
                target="_blank">{{'Stampa' | translate}}</a>
              </span>
              <span class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
                <i class="material-icons-outlined">email</i>
                <span (click)="emailVoucher()">{{'Invia via mail' | translate}}</span>
              </span>
            </div>
          }
          @if (["draft", "unconfirmed"].includes(record.status)) {
            <div class="suspend"
              (click)='suspendBooking()'>
              <span
              class="material-icons-outlined">pause_circle</span> {{ 'Sospendi prenotazione' | translate}}
            </div>
          }
          @if (!["confirmed", "optional", "mix"].includes(record.status) && (record.booking_type != 1 || !["expired", "canceled"].includes(record.status))) {
            <div class="block"
              (click)='optionalBooking()'
              [matTooltip]='"Bloccal il preventivo fino a una scadenza (Mantiene i posti riservati)" | translate'>
              <span class="material-icons-outlined">push_pin</span> {{ 'Blocca preventivo' | translate}}
            </div>
          }
          @if (record.allowed_actions.includes('delete') && record.domain.code!=='forexchange') {
            @if (["confirmed", "optional", "mix"].includes(record.status)) {
              <div class="annulla"
                (click)='cancelBooking()'>
                <span
                class="material-icons-outlined">cancel</span> {{ 'Annulla prenotazione' | translate}}
              </div>
            }
          }
        </div>
        <trip-booking-summary
          [record]='record'
          [extraParams]='{channel_value: channelValue, user_name: creatorName, online_order_id: onlineOrderId}'
        ></trip-booking-summary>
      </div>
      @if (datasetRS.record.value.participant_count > 0 && datasetRS.record.value.packages.length > 0 && fees>0) {
        <div class="total fx-row fx-justify-space-around fx-items-center">
          <span class="totale">{{'Diritti Agenzia' | translate}}:</span>
          <span class="importo">{{ fees | currency:"EUR" }}</span>
        </div>
      }
      <!-- TODO: verificare che ci sia un intestatario e un cliente anche -->
      @if (datasetRS.record.value.participant_count > 0 && datasetRS.record.value.packages.length > 0) {
        <div class="total fx-row fx-justify-space-around fx-items-center">
          <span class="totale">{{'Totale' | translate}}:</span>
          <span class="importo">{{ datasetRS.record.value.total_amount | currency:"EUR" }}</span>
        </div>
      }
      <div class="footer fx-row fx-justify-center fx-items-center">
        <div [matTooltip]="confirmTooltip">
          <button [ngClass]="{'disabled': !canConfirm, 'confirm': canConfirm}" [disabled]="!canConfirm"
            (click)="confirmBooking()">
            {{ 'Conferma prenotazione' | translate}}
          </button>
        </div>
      </div>
    </fuse-sidebar>
  }
</div>
</div>

<!-- navigation mobile -->
<!-- TODO: creare componente -->

@if (record) {
  <div class="grow"
    [ngClass]='{"expanded": bottomBarState !== "false"}'
    [@grow]='{value: bottomBarState, params: {bottomBarHeight: "67px", bottom: bottom, bookingReviewHeight: bookingReviewHeight}}'>
    <div [ngClass]='{"no-shadow": bottomBarState !== "false"}' (click)='bookingReviewBarToggle()' class="tab fx-row fx-justify-start fx-items-center" style="gap: 6px">
      <span class="material-icons-outlined">{{ bottomBarState == 'false' ? 'expand_less' : 'expand_more' }}</span>
      <span class="tab-label">{{ 'Riepilogo' | translate }}</span>
    </div>
    <div fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}" class="mobile-booking-review fx-column fx-justify-space-between fx-items-start fx-flex-1-1-auto">
      @if (datasetRS.loading.value) {
        <div class="overlay"></div>
      }
      <div class="fx-column fx-flex-1-1-0" style="width: 100%; gap: 24px">
        <trip-booking-summary
          [record]='record'
          [extraParams]='{channel_value: channelValue, user_name: creatorName, online_order_id: onlineOrderId}'
        ></trip-booking-summary>
      </div>
      <div class="footer fx-column">
        <div class="actions fx-column">
          @if (["confirmed"].includes(record.status)) {
            <div class="voucher-actions fx-column fx-justify-start fx-items-start" style="gap: 10px">
              <h4 style="margin-top: 0;">{{'Voucher prenotazione' | translate}}</h4>
              <span class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
                <i class="material-icons-outlined">print</i>
                <a class="print-voucher"
                  [href]='appService.getBaseServerAddressRoot() + "/voucher/download/by/id/" + datasetRS.recordId'
                target="_blank">{{'Stampa' | translate}}</a>
              </span>
              <span class="fx-row fx-justify-start fx-items-center" style="gap: 8px">
                <i class="material-icons-outlined">email</i>
                <span (click)="emailVoucher()">{{'Invia via mail' | translate}}</span>
              </span>
            </div>
          }
          @if (["draft", "unconfirmed"].includes(record.status)) {
            <div class="suspend"
              (click)='suspendBooking()'>
              <span
              class="material-icons-outlined">pause_circle</span> {{ 'Sospendi prenotazione' | translate}}
            </div>
          }
          @if (!["confirmed", "optional"].includes(record.status) && (record.booking_type != 1 || !["expired", "canceled"].includes(record.status))) {
            <div class="block"
              (click)='optionalBooking()'
              [matTooltip]='"Bloccal il preventivo fino a una scadenza (Mantiene i posti riservati)" | translate'>
              <span class="material-icons-outlined">push_pin</span> {{ 'Blocca preventivo' | translate}}
            </div>
          }
          @if (record.allowed_actions.includes("delete")&& record.domain.code!=="forexchange") {
            @if (["confirmed", "optional"].includes(record.status)) {
              <div class="annulla"
                (click)='cancelBooking()'>
                <span class="material-icons-outlined">cancel</span> {{ 'Annulla prenotazione' | translate}}
              </div>
            }
          }
          <div class="confirm" [matTooltip]="confirmTooltip">
            <button [ngClass]="{'disabled': !canConfirm, 'confirm': canConfirm}"  [disabled]="!canConfirm"
              (click)="confirmBooking()">
              {{ 'Conferma prenotazione' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- bottom fixed bar -->
  <div #bottomFixedBar class="trip-booking-bottom-fixed-bar fx-row fx-justify-space-between fx-items-center">
    <div class="total-mobile-review fx-column fx-justify-start fx-items-stretch" style="gap: 8px">
      <span class="label">{{'Totale' | translate}}:</span>
      <span>{{ record.total_amount | currency:"EUR" }}</span>
    </div>
    <div class="navigation-pager fx-row fx-justify-space-between fx-items-center fx-flex-1-1-auto">
      @if (stepIndex > 0) {
        <div (click)="bookingStepperComponent.previous()" class="fx-row fx-justify-start fx-items-center">
          <button class="prev-step fx-row fx-justify-start fx-items-center" style="gap: 8px">
            <span class="material-icons-outlined">arrow_back_ios</span>
            <span>{{ 'Indietro' | translate }}</span>
          </button>
        </div>
      }
      @if (stepIndex < 3) {
        <div class="fx-row fx-justify-end fx-items-center fx-flex-1-1-auto">
          <button (click)="bookingStepperComponent.next()" class="next-step fx-row fx-justify-start fx-items-center" style="gap: 8px">
            <span>{{ 'Salva' | translate }}</span>
            <span class="material-icons-outlined">arrow_forward_ios</span>
          </button>
        </div>
      }
    </div>
  </div>
}